import { InstructorUtilization } from "../instructorUtilization/InstructorUtilization";
import { InstructorClosingConversion } from "../instructorClosingConversion/InstructorClosingConversion";
import { FirstVisitConversions } from "../instructorFirstVisitConversions/InstructorFirstVisitConversions";

export const MODULES = {
  instructorUtilization: {
    Component: InstructorUtilization,
    moduleName: "instructorUtilization"
  },
  instructorClosingConversion: {
    Component: InstructorClosingConversion,
    moduleName: "instructorClosingConversion"
  },
  firstVisitConversions: {
    Component: FirstVisitConversions,
    moduleName: "firstVisitConversions"
  }
};

export const api = {
  instructorUtilization: "class_utilization",
  instructorClosingConversion: "closing_conversion",
  firstVisitConversions: "first_visit_conversions"
};
